import { useGrowl } from "PFApp/use_growl";
import SectionBox from "PFComponents/box/section_box";
import Modal from "PFComponents/modal/modal";
import { getProfileName } from "PFCore/helpers/profile";
import { useErrorsGrowl } from "PFCore/hooks/use_errors_growl";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import { editRequest } from "../api";
import { ExceptionModalContent } from "./parts/exception_modal_content";

const EditRequestModal = ({ close, role, exception, shortlistItem, onSuccess }) => {
  const growl = useGrowl();
  const { t } = useTranslation("auditPlanner");
  const growlErrors = useErrorsGrowl();

  const handleUpdate = (approver) => {
    editRequest(shortlistItem.id, approver.id)
      .then(() => {
        if (onSuccess) {
          onSuccess();
        }
        close();
        growl({
          kind: "success",
          message: t("modals.requestForApprovalSubmitted", {
            name: getProfileName(approver)
          })
        });
      })
      .catch((response) => {
        new growlErrors(response);
      });
  };

  return (
    <Modal closeOnBackdropClick handleClose={close} style={{ maxWidth: 900, margin: "0 auto" }}>
      <SectionBox>
        <ExceptionModalContent
          close={close}
          confirm={(note, approver) => handleUpdate(approver)}
          exception={exception.exceptions}
          approver={exception.approver}
          requester={exception.requester}
          request_reason={exception.request_reason}
          role={role}
          isEditModal
          shortlistItem={shortlistItem}
        />
      </SectionBox>
    </Modal>
  );
};

EditRequestModal.propTypes = {
  close: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  exception: PropTypes.object.isRequired,
  role: PropTypes.object.isRequired,
  shortlistItem: PropTypes.shape({ id: PropTypes.number.isRequired, profile: PropTypes.object.isRequired })
    .isRequired
};

export default EditRequestModal;
